import { render, staticRenderFns } from "./Func55ExtratoUtilizacao.vue?vue&type=template&id=520a8c45&scoped=true"
import script from "./Func55ExtratoUtilizacao.vue?vue&type=script&lang=js"
export * from "./Func55ExtratoUtilizacao.vue?vue&type=script&lang=js"
import style0 from "./Func55ExtratoUtilizacao.vue?vue&type=style&index=0&id=520a8c45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a8c45",
  null
  
)

export default component.exports